// client/src/services/marketplaceOrderService.js
import axios from '../utils/axiosConfig';

export const listPartnerVenues = () => axios.get('/orders/marketplace/venues').then(r => r.data.venues);
export const getVenueRoomAvailability = (venueId, roomId, date) =>
  axios.get(`/orders/marketplace/venues/${venueId}/availability`, { params: { roomId, date } }).then(r => r.data.slots);

export const createDraftOrder = (data) => axios.post('/orders/marketplace', data).then(r => r.data.order);
export const getMyOrders = () => axios.get('/orders/marketplace/mine').then(r => r.data.orders);
export const getOrder = (id) => axios.get(`/orders/marketplace/${id}`).then(r => r.data.order);
export const cancelOrder = (id, reason) => axios.post(`/orders/marketplace/${id}/cancel`, { reason }).then(r => r.data.order);
export const confirmCompletion = (id) => axios.post(`/orders/marketplace/${id}/confirm-completion`).then(r => r.data.order);
export const reportNoShow = (id) => axios.post(`/orders/marketplace/${id}/report-no-show`).then(r => r.data.order);

export const verifyMarketplacePayment = (reference, orderId) =>
  axios.post('/payment/marketplace/verify', { reference, orderId }).then(r => r.data);
